import { IContentPage } from '@/models/content-page.model';
import { SupportedLocales } from '@/models/localization.model';
import { isValidHttpOrHttpsUrl } from './isValidHttpOrHttpsUrl';

const TITLE_MAX = 255;
const COVER_URL_MAX = 2048;

export type TBlogPostValidationError = {
  messageKey: string;
  values?: Record<string, string | number>;
  invalidNameLocales?: SupportedLocales[];
  invalidSlugLocales?: SupportedLocales[];
};

/**
 * Client-side checks aligned with BlogPostDraftStoreRequest / BlogPostDraftUpdateRequest (meta + cover).
 */
export function validateBlogPostPage(page: IContentPage, locales: SupportedLocales[]): TBlogPostValidationError | null {
  for (const loc of locales) {
    const name = page.localeMeta?.[loc]?.name?.trim() ?? '';
    if (!name) {
      return {
        messageKey: 'validation_blog_name_required',
        values: { locale: loc.toUpperCase() },
        invalidNameLocales: [loc],
      };
    }
    if (name.length > TITLE_MAX) {
      return {
        messageKey: 'validation_blog_name_max',
        values: { locale: loc.toUpperCase(), max: TITLE_MAX },
        invalidNameLocales: [loc],
      };
    }
  }

  const cover = page.coverImage?.trim() ?? '';
  if (!cover) {
    return { messageKey: 'validation_blog_cover_required' };
  }
  if (cover.length > COVER_URL_MAX) {
    return { messageKey: 'validation_blog_cover_url_max', values: { max: COVER_URL_MAX } };
  }
  if (!isValidHttpOrHttpsUrl(cover)) {
    return { messageKey: 'validation_blog_cover_url_invalid' };
  }

  return null;
}
